import { AxiosResponse } from "axios";
import API from "../api";

const endpoint = "amos";

const AmosService = {
  async send(jobId: number): Promise<AxiosResponse<void>> {
    return API.post(`/${endpoint}/send`, { jobId });
  },
  async sendQuoteToAmos(jobId: number): Promise<AxiosResponse<void>> {
    return API.post(`/${endpoint}/quote/send`, { jobId });
  },
  async sendOrderToAmos(jobId: number): Promise<AxiosResponse<void>> {
    return API.post(`/${endpoint}/order/send`, { jobId });
  },
};

export default AmosService;
